import { render, staticRenderFns } from "./ExpenseModal.vue?vue&type=template&id=648e4721&scoped=true"
import script from "./ExpenseModal.vue?vue&type=script&lang=js"
export * from "./ExpenseModal.vue?vue&type=script&lang=js"
import style0 from "./ExpenseModal.vue?vue&type=style&index=0&id=648e4721&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "648e4721",
  null
  
)

export default component.exports